import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ticker-content" }
const _hoisted_2 = {
  key: 0,
  class: "ticker-separator-container"
}
const _hoisted_3 = { class: "ticker-text" }
const _hoisted_4 = {
  class: "ticker-content",
  "aria-hidden": "true"
}
const _hoisted_5 = {
  key: 0,
  class: "ticker-separator-container"
}
const _hoisted_6 = { class: "ticker-text" }

import {computed} from 'vue';

const __default__ = {
  name: "TickerWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    config: {
        type: Object,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const tickerTexts = computed(() => {
  if (Array.isArray(props.config.texts) && props.config.texts.length > 0) {
    return props.config.texts.map((t: { text: string }) => t.text);
  }
  // For testing, use a long string if empty
  return [props.config.text || "This is a sample ticker text. Add more items for sliding effect."];
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "widget-ticker",
    style: _normalizeStyle({
        background: __props.config?.backgroundColor || '#000',
        color: __props.config?.fontColor || '#fff',
        fontSize: (__props.config?.fontSize || 20) + 'px',
        fontFamily: __props.config?.fontFamily || 'Arial',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
    })
  }, [
    _createElementVNode("div", {
      class: "ticker-track-horizontal",
      style: _normalizeStyle({
          animationDuration: (__props.config?.tickerSpeed || 10) + 's',
        })
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickerTexts.value, (text, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _createElementVNode("span", {
                    class: "ticker-separator",
                    style: _normalizeStyle({
                  color: __props.config?.seperatorColor || '#000000',
                  padding: `0 ${__props.config?.separatorPadding || 10}px`,
                })
                  }, _toDisplayString(__props.config?.separator || "|"), 5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, _toDisplayString(text), 1)
          ], 64))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tickerTexts.value, (text, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: 'dup-' + index
          }, [
            (index > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "ticker-separator",
                    style: _normalizeStyle({
                  color: __props.config?.seperatorColor || '#000000',
                  padding: `0 ${__props.config?.separatorPadding || 10}px`,
                })
                  }, _toDisplayString(__props.config?.separator || "|"), 5)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_6, _toDisplayString(text), 1)
          ], 64))
        }), 128))
      ])
    ], 4)
  ], 4))
}
}

})